import { useCallback, useEffect, useMemo, useState, type ReactNode } from 'react';
import { PARENT_SESSION_MS, ParentSessionContext } from './useParentSession';

export function ParentSessionProvider({ children }: { children: ReactNode }) {
  const [unlockedAt, setUnlockedAt] = useState<number | null>(null);

  useEffect(() => {
    if (unlockedAt === null) return;
    const timer = window.setTimeout(() => setUnlockedAt(null), PARENT_SESSION_MS);
    return () => window.clearTimeout(timer);
  }, [unlockedAt]);

  const unlock = useCallback(() => setUnlockedAt(Date.now()), []);
  const lock = useCallback(() => setUnlockedAt(null), []);
  const value = useMemo(
    () => ({ unlocked: unlockedAt !== null, unlock, lock }),
    [unlockedAt, unlock, lock],
  );
  return <ParentSessionContext.Provider value={value}>{children}</ParentSessionContext.Provider>;
}
